module.exports = __webpack_public_path__ + "25606f3e0acd5abd46eb0e9d706e862c.png";